<div class="bg-[#f2f2f2]">
  <div class="m-auto lg:w-[850px] border-t border-gray-600" />
  <div
    class="flex justify-evenly items-center text-[#000032] font-poppins
    font-medium flex-wrap lg:w-2/3 m-auto">
    <div class=" w-[200px] h-[200px] lg:w-[300px] lg:h-[300px]">
      <img src="images/logo-vertical-colorido-sem-fundo-1024x1024.png" alt="" />
    </div>
    <div class="text-center lg:text-left text-sm lg:text-xl mt-[-60px] w-96 lg:w-2/5">
      <p class="pt-6">
        Copyright 2021 © Todos os direitos reservados para Fabiana Nanô.
      </p>
      <p class="pt-6">CNPJ: 24.922.623/0001-80</p>
      <p class="pt-6">E-mail de contato: fabiana@fabiananano.com</p>
    </div>
  </div>
  <p
    class="text-center text-[#003869] w-80 lg:w-4/5 font-light pb-8 text-[14px]
    font-poppins lg:mt-[-50px] leading-4 m-auto pb-16 pt-6">
    Esse produto é comercializado com apoio da Hotmart. A plataforma não faz
    controle editorial prévio dos produtos comercializados, nem avalia a
    tecnicidade e experiência daqueles que os produzem. A existência de um
    produto e sua aquisição, por meio da plataforma, não podem ser consideradas
    como garantia de qualidade de conteúdo e resultado, em qualquer hipótese. Ao
    adquiri-lo, o comprador declara estar ciente dessas informações. Os termos e
    políticas da Hotmart podem ser acessados aqui, antes mesmo da conclusão da
    compra.
  </p>
</div>
